import React from "react";
import { STATUS_META } from "@/lib/format";

export function StatusBadge({ status, className = "" }) {
  const m = STATUS_META[status] || STATUS_META["Draft"];
  return (
    <span
      data-testid={`status-badge-${status.replace(/\s+/g, "-").toLowerCase()}`}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ${m.bg} ${m.text} ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: m.dot }} />
      {status}
    </span>
  );
}
